import { ZodError } from 'zod';
import { captureException } from '@sentry/browser';

import { apiClient } from '@f/api-client';

import { createAction } from '../actions';

export const API_TOKEN_FIND_START = 'API_TOKEN_FIND_START';
export const API_TOKEN_FIND_FULFILL = 'API_TOKEN_FIND_FULFILL';
export const API_TOKEN_FIND_REJECT = 'API_TOKEN_FIND_REJECT';

export const API_TOKEN_CREATE_START = 'API_TOKEN_CREATE_START';
export const API_TOKEN_CREATE_FULFILL = 'API_TOKEN_CREATE_FULFILL';
export const API_TOKEN_CREATE_REJECT = 'API_TOKEN_CREATE_REJECT';

export const API_TOKEN_REMOVE_START = 'API_TOKEN_REMOVE_START';
export const API_TOKEN_REMOVE_FULFILL = 'API_TOKEN_REMOVE_FULFILL';
export const API_TOKEN_REMOVE_REJECT = 'API_TOKEN_REMOVE_REJECT';

export function findApiTokens() {
  return async dispatch => {
    // Starts
    dispatch(createAction(API_TOKEN_FIND_START));

    try {
      const result = await apiClient.apiToken.fetchTokens();

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      // Fulfills
      dispatch(createAction(API_TOKEN_FIND_FULFILL, { result: result.body }));
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      // Rejects
      dispatch(createAction(API_TOKEN_FIND_REJECT, error));
    }
  };
}

export function createApiToken(data) {
  return async dispatch => {
    // Starts
    dispatch(createAction(API_TOKEN_CREATE_START));

    try {
      const result = await apiClient.apiToken.createToken({
        body: data,
      });

      if (result.status !== 201) {
        throw new Error(result.body);
      }

      // Fulfills
      dispatch(createAction(API_TOKEN_CREATE_FULFILL, { result: result.body.token }));
      return result.body;
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      // Rejects
      dispatch(createAction(API_TOKEN_CREATE_REJECT, error));
    }
  };
}

export function removeApiToken(id) {
  return async dispatch => {
    // Starts
    dispatch(createAction(API_TOKEN_REMOVE_START));

    try {
      const result = await apiClient.apiToken.removeToken({
        body: { id },
      });

      if (result.status !== 200) {
        throw new Error(result.body);
      }

      // Fulfills
      dispatch(createAction(API_TOKEN_REMOVE_FULFILL, { result: result.body }));
    } catch (error) {
      if (error instanceof ZodError) {
        captureException(error);
      }
      // Rejects
      dispatch(createAction(API_TOKEN_REMOVE_REJECT, error));
    }
  };
}
